import React from "react";
import {
  FaPlane,
  FaHotel,
  FaPassport,
  FaIdCard,
  FaShieldAlt,
  FaPhoneAlt,
  FaCheckCircle,
  FaFileContract,
} from "react-icons/fa";
import "./Servs.css";
import { Link } from "react-router-dom";

const TOURISM_LICENSE_NUMBER = "73104281";

const services = [
  {
    id: 1,
    title: "حجز تذاكر طيران",
    description: "نوفر خدمة حجز تذاكر الطيران بأفضل الأسعار والعروض.",
    icon: <FaPlane />,
    licenseNumber: TOURISM_LICENSE_NUMBER,
    priceText:
      "يتم توضيح السعر النهائي شامل ضريبة القيمة المضافة والرسوم النظامية قبل تأكيد الطلب.",
  },
  {
    id: 2,
    title: "حجز فنادق",
    description: "نقدم خيارات متنوعة لحجز الفنادق بأعلى مستوى من الراحة.",
    icon: <FaHotel />,
    licenseNumber: TOURISM_LICENSE_NUMBER,
    priceText:
      "يتم توضيح السعر النهائي حسب الفندق ومدة الإقامة شامل ضريبة القيمة المضافة والرسوم النظامية.",
  },
  {
    id: 3,
    title: "رخص دولية",
    description: "نساعدك في استخراج الرخص الدولية بسرعة وسهولة.",
    icon: <FaIdCard />,
    licenseNumber: TOURISM_LICENSE_NUMBER,
    priceText:
      "يتم توضيح السعر النهائي شامل ضريبة القيمة المضافة والرسوم النظامية قبل تأكيد الطلب.",
  },
  {
    id: 4,
    title: "تأمين طبي",
    description: "نوفر لك خدمات التأمين الطبي المناسبة لمتطلبات سفرك.",
    icon: <FaShieldAlt />,
    licenseNumber: TOURISM_LICENSE_NUMBER,
    priceText:
      "يتم توضيح السعر النهائي حسب نوع التأمين ومدة التغطية شامل ضريبة القيمة المضافة والرسوم النظامية.",
  },
  {
    id: 5,
    title: "تأشيرات",
    description: "نساعدك في إنهاء إجراءات التأشيرات بكل سهولة واحترافية.",
    icon: <FaPassport />,
    licenseNumber: TOURISM_LICENSE_NUMBER,
    priceText:
      "يتم توضيح السعر النهائي شامل ضريبة القيمة المضافة والرسوم النظامية قبل تأكيد الطلب.",
  },
];

export default function Servs() {
  const publishedServices = services.filter((service) => service.licenseNumber);

  return (
    <>
      <section className="services-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">خدماتنا</h2>
            <p className="services-compliance-note">
              جميع الخدمات المعروضة موضحة ببيانات الترخيص، ويتم توضيح السعر
              النهائي شامل ضريبة القيمة المضافة والرسوم النظامية قبل تأكيد الطلب
              مع فريق المبيعات.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {publishedServices.map((service) => (
              <div key={service.id} className="col-md-6 col-lg-4">
                <div className="service-box text-center p-4 h-100 shadow-sm">
                  <div className="icon-wrapper mb-3">{service.icon}</div>

                  <h5 className="fw-bold mb-2">{service.title}</h5>

                  <p className="text-muted">{service.description}</p>

                  <div className="service-compliance-data">
                    <p>
                      <FaIdCard />
                      <span>
                        رقم الترخيص السياحي:{" "}
                        <strong>{service.licenseNumber}</strong>
                      </span>
                    </p>

                    <p>
                      <FaCheckCircle />
                      <span>{service.priceText}</span>
                    </p>

                    <p>
                      <FaFileContract />
                      <Link to="/cancellation-policy">
                        سياسة الإلغاء والتعديل
                      </Link>
                    </p>
                  </div>

                <Link
  to="/contact"
  className="btn btn-light btn-lg rounded-pill px-4 fw-bold contact-btn"
>
  اطلب الخدمة الآن
</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="contact-banner container my-5">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white gap-3 px-4 py-3">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <FaPhoneAlt className="fs-4" />

            <a
              href="tel:920033239"
              className="text-white fw-bold text-decoration-none me-2"
            >
              920033239
            </a>

            <span className="text-white">|</span>

            <a
              href="https://wa.me/966920033239"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white fw-bold text-decoration-none ms-2"
            >
              واتساب 24/7
            </a>
          </div>

          <div className="text-center flex-grow-1 fw-bold fs-5">
            ابدأ تجربتك معنا الآن
          </div>

          <Link to="/contact" className="service-book-btn">
            اطلب الخدمة الآن
          </Link>
        </div>
      </div>
    </>
  );
}
